"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DonateHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="254274" id="donate-hero" className="relative w-full bg-background text-foreground overflow-hidden py-24 md:py-32 lg:py-40 flex items-center justify-center min-h-[40vh]">
      {}
      <div className="absolute top-0 right-0 w-full h-full overflow-hidden pointer-events-none flex justify-end items-start z-0">
        <div className="relative w-[600px] h-[600px] md:w-[800px] md:h-[800px] -mt-[300px] -mr-[300px] md:-mt-[400px] md:-mr-[400px] opacity-40 dark:opacity-20">
          <div className="absolute inset-0 rounded-lg border border-secondary/30 bg-gradient-to-br from-secondary/10 to-transparent"></div>
          <div className="absolute inset-[60px] md:inset-[100px] rounded-lg border border-primary/20"></div>
          <div className="absolute inset-[120px] md:inset-[200px] rounded-lg border border-secondary/20"></div>
          <div className="absolute inset-[180px] md:inset-[300px] rounded-lg border border-primary/10"></div>
        </div>
      </div>

      {}
      <div ref={ref} className={`container px-4 md:px-6 relative z-10 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-primary font-default tracking-tighter mb-6">
          Your Support Saves Lives
        </h1>
        
        <p className="max-w-[700px] mx-auto text-lg md:text-xl text-muted-foreground font-default mb-8 leading-relaxed">
          Every donation ensures that life-saving prescriptions reach those in need, bridging the gap between patient care and essential medicine access.
        </p>

        <p className="max-w-[700px] mx-auto text-lg md:text-xl text-muted-foreground font-default mb-8 leading-relaxed">
          Got Meds is a not‑for‑profit organization.
        </p>

        <nav aria-label="Breadcrumb" className="flex items-center justify-center space-x-2 text-sm md:text-base text-muted-foreground font-medium"></nav>
      </div>
    </section>;
}